import React, { useContext, useEffect, useState } from 'react';
import Moment from 'react-moment';
import axios from 'axios';
import AuthContext from '../authentication/AuthContext';
import UserContext from '../user/UserContext';
import { useAlert } from 'react-alert';

export default function DeliveryInformation() {
    let [deliveryDetails, setDeliveryDetails] = useState([]);

    let cas = useContext(AuthContext);
    let { userDetails } = useContext(UserContext);

    let alert = useAlert();

    useEffect(() => {
        if (
            userDetails.currentFranchise &&
            !(userDetails.currentFranchise.onHold && !userDetails.currentFranchise.payOnOrder) &&
            userDetails.currentFranchise.status !== 'Closed'
        ) {
            axios
                .get(
                    window.CONFIG['ws.activoc-web-order-api.dhl-delivery-schedule-service'].replace(
                        '{franchiseCode}',
                        userDetails.currentFranchise.code
                    ),
                    {
                        headers: {
                            Authorization: cas,
                            'Content-Type': 'application/json'
                        }
                    }
                )
                .then(response => setDeliveryDetails(response.data))
                .catch(() => alert.error("ERROR: Unable to retrieve today's delivery information."));
        }
        // eslint-disable-next-line
    }, [cas, userDetails]);

    return (
        <div>
            {deliveryDetails && deliveryDetails.length > 0 && (
                <>
                    <span>
                        You have {deliveryDetails.length}{' '}
                        {deliveryDetails.length === 1 ? 'delivery' : 'deliveries'} today:
                    </span>
                    <ol>
                        {deliveryDetails.map(delivery => {
                            let delivered = !!delivery.deliveredDateTime;
                            let deliveryTime = delivered
                                ? delivery.deliveredDateTime
                                : delivery.expectedDeliveryDateTime;

                            return (
                                <li key={deliveryTime}>
                                    {delivered ? 'Delivered at: ' : 'Delivery ETA: '}
                                    <strong>
                                        <Moment format={'HH:mm'}>{deliveryTime}</Moment>
                                    </strong>
                                </li>
                            );
                        })}
                    </ol>
                </>
            )}
        </div>
    );
}
